import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from '@mui/material';
import ReviewProgramItem from './item/ReviewProgramItem';
import axios from '../../config/axios';
import Iframe from 'react-iframe';
import { ExpandMore } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'Poppins',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '27px',
    letterSpacing: '0.1px',
    color: '#171725',
  },
  answerText: {
    fontWeight: 600,
  },
}));

const PersonalRecommendationsFormReview = ({
  recommendersForm,
  registeredProgram,
  recommendersResponseForm,
}) => {
  const classes = useStyles();
  console.log(
    registeredProgram.personalRecommenderFormDocNo,
    'registeredProgram'
  );
  console.log(recommendersResponseForm, 'recommendersResponseForm');
  const [showLink, setShowLink] = useState(false);
  const [formLink, setFormLink] = useState('');
  const [attachementId, setAttachementId] = useState();
  const [newLink, setNewLink] = useState(false);
  //personalRecommenderFormDocNo
  useEffect(() => {
    if (registeredProgram?.personalRecommenderFormDocNo) {
      axios
        .get('/documentLinkFunctions/getDocument', {
          // .get('/documentAttachLinkFunctions/documentAttachLink', {
          params: {
            docId: registeredProgram?.personalRecommenderFormDocNo,
          },
        })
        .then((res) => {
          console.log(res.data, 'res.data====>');
          setAttachementId(res.data.attachment_id);

          console.log(res.data.link, 'mmmmm ===> 1');
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [registeredProgram?.personalRecommenderFormDocNo]);
  useEffect(() => {
    if (registeredProgram?.personalRecommenderFormDocNo) {
      axios
        .get('/documentLinkFunctions/documentDownloadLink', {
          // .get('/documentAttachLinkFunctions/documentAttachLink', {
          params: {
            docId: registeredProgram?.personalRecommenderFormDocNo,
          },
        })
        .then((res) => {
          console.log(res.data, 'res.data download link');
          setFormLink(res.data.link);
          setShowLink(true);
          console.log(res.data.link, 'mmmmm');
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [registeredProgram?.personalRecommenderFormDocNo]);

  useEffect(() => {
    const fetchData = () => {
      if (registeredProgram?.personalRecommenderFormDocNo) {
        axios
          .get('/documentLinkFunctions/downloadAttachment', {
            // .get('/documentAttachLinkFunctions/documentAttachLink', {
            params: {
              docId: registeredProgram?.personalRecommenderFormDocNo,
              attachtmentId: attachementId,
            },
          })
          .then((res) => {
            console.log(res.data, 'res.attachmentId');

            console.log(res.data, 'attachmentInside');
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };
    // Call fetchData after 10 seconds
    const timeoutId = setTimeout(fetchData, 10000);

    // Clean up function to clear the timeout if the component unmounts or when registeredProgram changes
    return () => clearTimeout(timeoutId);
  }, [registeredProgram, attachementId]);
  const saveInterval = 1 * 60 * 1000;
  // using this api for testing purpose
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (registeredProgram?.personalRecommenderFormDocNo) {
  //       axios
  //         .get('/documentAttachLinkFunctions/documentAttachLink', {
  //           params: {
  //             docId: registeredProgram.personalRecommenderFormDocNo,
  //           },
  //         })
  //         .then((res) => {
  //           console.log(res, 'after5min');
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         });
  //     }
  //   }, saveInterval);
  // }, []);
  console.log(formLink, 'formLink');
  const handleGetNewLink = () => {
    setNewLink(false);
    axios
      .get('/documentLinkFunctions/documentDownloadLink', {
        params: {
          docId: registeredProgram.personalRecommenderFormDocNo,
        },
      })
      .then((res) => {
        setFormLink(res.data.link);
        setShowLink(true);
        console.log(res.data.link, 'maaanishh');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Grid
      container
      direction={'column'}
      style={{ paddingTop: '0.5em', paddingBottom: '0.5em' }}
    >
      <Box>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            style={{ marginTop: '20px' }}
          >
            {/*RECOMMENDATIONS*/}
            <Grid item>
              <Typography className={classes.title}>
                Personal Recommendation
              </Typography>
            </Grid>
          </AccordionSummary>
          <AccordionDetails
            style={{ backgroundColor: '#FAFAFB', flexDirection: 'column' }}
          >
            {/*RECOMMENDER INFO*/}
            {recommendersForm.map((recommender) => (
              <ReviewProgramItem
                key={recommender.id}
                question={'Recommender Information'}
                value={
                  registeredProgram.personalRecommenderDetails
                    .recommenderTitle +
                  ' ' +
                  registeredProgram.personalRecommenderDetails
                    .recommenderFirstName +
                  ' ' +
                  registeredProgram.personalRecommenderDetails
                    .recommenderLastName
                }
                value2={
                  registeredProgram.personalRecommenderDetails
                    .recommenderEmailAddress
                }
              />
            ))}

            {/*RESPONSES*/}
            <Grid item>
              <Typography className={classes.title}>Document Link</Typography>
            </Grid>

            <ReviewProgramItem
              question={'SignNow Link'}
              value={formLink}
              showLink={showLink}
              link={true}
            />
            {/*
      <Iframe
        url={formLink}
        width="100%"
        height="800px"
        id=""
        className=""
        display="block"
        position="relative"
      />*/}
          </AccordionDetails>
        </Accordion>
      </Box>
    </Grid>
  );
};

export default PersonalRecommendationsFormReview;
